import { useThemeListTabModel } from './theme-list-tab.model'
import { ThemeListTabView } from './theme-list-tab.view'

export const ThemeListTab = () => {
  const themeListTabModel = useThemeListTabModel()
  return <ThemeListTabView {...themeListTabModel} />
}
